import request from '../request'

export function sendCode(mobile) {
  const url = '/sms/send'
  return request.get(url, {
    params: {mobile}
  })
}

export function verifyCode(mobile, captcha) {
  const url = '/user/set_user_3_day_vip'
  return request.get(url, {
    params: {
      mobile,
      captcha
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/activity/bindphone.js